<template lang="pug">
div
	// Botón de componer
	.wrapperRedactar
		.text-center
			button.btn.btn-primary.btn-lg.btn-labeled(style="box-shadow: 0 0 5px rgba(0,0,0,0.2);", @click="redactar = true")
				span.btn-label.fa.fa-edit.mr-2
				span Redactar
	ul.listadoBuzones
		Buzon(
			v-for="buzon in buzones"
			:key="buzon.Name"
			:buzon="buzon"
			@selected="seleccionaBuzon($event)"
		)
	
	b Etiquetas
	redactar-email(v-if="redactar", @cerrar="redactar = false")
</template>

<script>
import Buzon from './buzon'
import { mapGetters, mapMutations, mapActions } from 'vuex'
export default {
	components: {
		Buzon
	},
	data () {
		return {
			buzonSeleccionado: 'INBOX',
			redactar: false
		}
	},
	created () {
		// this.cargaBuzonInicial()
	},
	watch: {
		listadoBuzones: function () {
			this.cargaBuzonInicial()
		}
	},
	computed: {
		...mapGetters({
			buzones: 'webmail/buzonesAnidados'
		})
	},
	methods: {
		...mapMutations({
			setBuzonActivo: 'webmail/SELECCIONA_BUZON'
		}),
		...mapActions({
			getMensajes: 'webmail/getMensajes'
		}),
		cargaBuzonInicial () {
			if (this.$route.params.buzon) {
				const buzonActivo = this.listadoBuzones.filter(b => b.Path === this.$route.params.buzon)

				if (buzonActivo.length === 0) {
					// buscamos el INBOX
					const inbox = this.listadoBuzones.filter(b => b.Path === 'INBOX')[0]
					this.seleccionaBuzon(inbox)
					return
				}
				this.seleccionaBuzon(buzonActivo[0])
			} else {
				// Vamos a por el INBOX
				const inbox = this.listadoBuzones.filter(b => {
					return (b.Path === 'INBOX')
				})
				if (inbox.length > 0) {
					console.log('INBOX encontrado')
					this.seleccionaBuzon(inbox[0])
				}
			}
		},
		seleccionaBuzon (buzon) {
			this.setBuzonActivo(buzon)
			this.getMensajes()
		}
	}
}
</script>

<style scoped>
.wrapperRedactar {
	padding: 0;
	padding-bottom: 10px;
}

ul.listadoBuzones {
	list-style-type: none;
	margin: 0;
	padding: 0;
	font-size: 1em;
	padding-bottom: 15px;
	border-bottom: 1px solid #e0e0e0;
}

ul.listadoBuzones > li {
	display: flex;
	flex-direction: column;
	width: 100%;
	margin: 0;
	cursor: pointer;
	transition: opacity 300ms ease-out;
}

ul.listadoBuzones > li.active {
	opacity: 1;
}

ul.listadoBuzones > li.active > .nombre {
	font-weight: bold;
}

ul.listadoBuzones > li > .icono {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 30px;
	max-width: 30px;
	text-align: left;
}

ul.listadoBuzones > li > .nombre {
	flex-grow: 1;
	flex-shrink: 1;
	text-align: left;
}

ul.listadoBuzones > li > .contadorMensajes {
	flex-grow: 0;
	flex-shrink: 0;
	flex-basis: 30px;
	max-width: 30px;
	text-align: right;
}

.btn-label {position: relative;left: -12px;display: inline-block;padding: 6px 12px;background: rgba(0,0,0,0.15);border-radius: 3px 0 0 3px;}
.btn-labeled {padding-top: 0;padding-bottom: 0;}
.btn { margin-bottom:10px; }
</style>


// WEBPACK FOOTER //
// src/modulos/webmail/vue/components/buzones/buzones.vue